import { TOLGEE_GLOBALS } from 'utils'

const TOLGEE_PREFIX = 'DashboardUseCases'

export const DASHBOARD_USECASES = [
  {
    label: TOLGEE_GLOBALS.territoryAnalysis,
    value: 'territory_analysis',
    description: {
      key: `${TOLGEE_PREFIX}-territoryAnalysis-description`,
      defaultValue: 'Escolher as oportunidades culturais para minha estratégia',
    },
    icon: 'videoOutline',
    isZAIUseCase: true,
  },
  {
    label: TOLGEE_GLOBALS.territoryAnalysis,
    value: 'auto_territory_analysis',
    description: {
      key: `${TOLGEE_PREFIX}-territoryAnalysis-description`,
      defaultValue: 'Escolher as oportunidades culturais para minha estratégia',
    },
    icon: 'videoOutline',
    shouldHide: true,
  },
  {
    label: TOLGEE_GLOBALS.weeklyAgendaNew,
    value: 'weekly_schedule',
    description: {
      key: `${TOLGEE_PREFIX}-weeklySchedule-description`,
      defaultValue: 'Analisar o que está acontecendo em cada semana para compartilhar com seu time',
    },
    icon: 'agenda',
    isZAIUseCase: true,
  },
  {
    label: TOLGEE_GLOBALS.trendAnalysis,
    value: 'trend_analysis',
    description: {
      key: `${TOLGEE_PREFIX}-trendAnalysis-description`,
      defaultValue: 'Mapear tendências de assuntos para a minha marca',
    },
    icon: 'trending',
    isZAIUseCase: true,
  },
  {
    label: TOLGEE_GLOBALS.creatorsSearch,
    value: 'search_creators',
    description: {
      key: `${TOLGEE_PREFIX}-creatorsSearch-description`,
      defaultValue: 'Buscar e acompanhar competidores e outras marcas',
    },
    icon: 'creator',
    isZAIUseCase: true,
  },
  {
    label: TOLGEE_GLOBALS.others,
    value: 'other',
    description: {
      key: `${TOLGEE_PREFIX}-other-description`,
      defaultValue: 'Eu possuo um objetivo que não se encaixa com as outras opções listadas',
    },
    icon: 'horizontalDots',
  },
]
